module.exports = __webpack_public_path__ + "img/certificate_bg.a330b244.png";